module.exports = __webpack_public_path__ + "static/media/jean-philippe-delberghe.cee0e63a.jpg";